<template>
  <v-navigation-drawer
    v-model="dialog_status" absolute temporary>

    <div id="header-menubar">
      <div id="btn-menu">
        <img @click="open_menu=false" id="bt-logo" 
          src="/static/android-chrome-192x192.png">
      </div>
      <router-link tag="div" id="logo-wrap" class="pointer-element"
        :to="{name: 'lab'}">
        <div id="bt-title">BiblioTrees</div>
      </router-link>
    </div>

    <v-divider></v-divider>

    <v-list nav dense id="list-first">

      <v-subheader>{{ user_name }}'s LAB</v-subheader>

      <v-list-item :to="{name: 'lab'}">
        <div class="icon-wrap">
          <v-icon>mdi-cube-outline</v-icon>
        </div>
        <div>{{ $t("lab.projects") }}</div>
      </v-list-item>

      <!-- <v-list-item inactive>
        <div class="icon-wrap">
          <v-icon>mdi-library</v-icon>
        </div>
        <div>[{{ $t("lab.open_soon") }}] {{ $t("lab.library") }}</div>
      </v-list-item> -->

      <v-list-item :to="{name: 'watching-projects'}">
        <div class="icon-wrap">
          <v-icon>mdi-account-supervisor-circle</v-icon>
        </div>
        <div>{{ $t("lab.watching_projects") }}</div>
      </v-list-item>

      <v-divider></v-divider>

      <v-subheader>프리미엄</v-subheader>

      <v-list-item :to="{name: 'document-clip'}"
        :disabled="expired">
        <div class="icon-wrap">
          <v-icon>mdi-clipboard-outline</v-icon>
        </div>
        <div>{{ $t("lab.document_clip") }}</div>
      </v-list-item>

      <v-list-item :to="{name: 'reviews'}"
        :disabled="expired">
        <div class="icon-wrap">
          <v-icon>mdi-book-open-page-variant</v-icon>
        </div>
        <div>{{ $t("lab.my_reviews") }}</div>
      </v-list-item>

      <!-- <v-list-item inactive>
        <div class="icon-wrap">
          <v-icon>mdi-map-search</v-icon>
        </div>
        <div>트리 검색</div>
      </v-list-item> -->

      <!-- <v-list-item inactive>
        <div class="icon-wrap">
          <v-icon>mdi-newspaper</v-icon>
        </div>
        <div>라운지</div>
      </v-list-item> -->

    </v-list>

    <v-divider v-if="!!active_projects.length"></v-divider>

    <v-list-group v-model="open_projects" v-if="!!active_projects.length">
      <template v-slot:activator>
        <v-list-item-content>
          <v-list-item-title>{{ $t("lab.working_project") }}</v-list-item-title>
        </v-list-item-content>
      </template>
      <v-list-item dense v-for="proj in active_projects" :key="proj.proj_id"
        :to="{name: 'project', params: {id: proj.proj_id}}">
        {{ proj.title }}
      </v-list-item>
    </v-list-group>

    <v-divider></v-divider>

    <v-list dense>

      <v-list-item :to="{name: 'account'}">
        <div class="icon-wrap">
          <v-icon>mdi-account-box-outline</v-icon>
        </div>
        <div>{{ $t("account_modal.account") }}</div>
      </v-list-item>

      <v-list-item :to="{name: 'guide'}">
        <div class="icon-wrap">
          <v-icon>mdi-help-circle-outline</v-icon>
        </div>
        <div>{{ $t("welcome.support") }}</div>
      </v-list-item>

      <v-list-item @click="report_issue_visible=true">
        <div class="icon-wrap">
          <v-icon>mdi-comment-alert-outline</v-icon>
        </div>
        <div>{{ $t("issues.send_feedback") }}</div>
      </v-list-item>

    </v-list>

    <v-divider></v-divider>

    <div id="footer-menubar">
      <router-link tag="div" class="pointer-element footer-text"
        :to="{name: 'notice'}">
        <div>{{ $t('welcome.notice') }}</div>
      </router-link>
      <router-link tag="div" class="pointer-element footer-text"
        :to="{name: 'plans'}">
        <div>{{ $t('welcome.plans') }}</div>
      </router-link>
      <router-link tag="div" class="pointer-element footer-text"
        :to="{name: 'policy'}">
        <div>{{ $t('welcome.policy') }}</div>
      </router-link>
      <router-link tag="div" class="pointer-element footer-text"
        :to="{name: 'commercial-terms'}">
        <div>{{ $t('welcome.commercial_terms') }}</div>
      </router-link>
      <router-link tag="div" class="pointer-element footer-text"
        :to="{name: 'privacy'}">
        <div>{{ $t('welcome.privacy') }}</div>
      </router-link>
    </div>

    <!-- Modal -->
    <modal-report-issue
      :dialog.sync="report_issue_visible">
    </modal-report-issue>

  </v-navigation-drawer>
  
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      open_projects: false,
      active_projects: [],
      report_issue_visible: false,
    }
  },

  computed: {
    ...mapGetters({
      firstname: 'user/firstname',
      username: 'user/username',
      expired: 'auth/is_expired',
    }),

    user_name() {
      return !!this.firstname ? this.firstname : this.username
    },

    dialog_status: {
      get: function(value) {
        return this.dialog
      },
      set: function(value) {
        if (!value) { this.close() }
      },
    },
  },

  async created() {
    let projs = this.$store.getters['project/projects']
    if (projs === null) {
      try {
        await this.$store.dispatch('project/getProjects')
      } finally {
        projs = this.$store.getters['project/projects']
      }
    }
    this.active_projects = projs.filter(v => v.status == 1 && v.mode != 9)
  },

  methods: {
    close() {
      this.$emit('update:dialog', false)
    },
  },
}
</script>

<style scoped>

  /* Header */

  #header-menubar {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 60px;
    position: fixed;
    z-index: 1;
    background-color: #ffffff;
  }

  #btn-menu {
    width: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  #logo-wrap {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  #bt-logo {
    width: 24px;
    height: 24px;
    transform: translateY(1.5px);
    cursor: pointer;
  }

  #bt-title{
    font-family: "Bree Serif", serif;
    font-size: 16pt;
  }

  /* Lists */

  #list-first {
    margin-top: 60px;
  }

  .icon-wrap {
    width: 50px;
    display: flex;
    justify-content: left;
    align-items: center;
    padding-left: 8px;
  }

  /* Footer */

  #footer-menubar {
    padding: 25px;
    display: flex;
    flex-wrap: wrap;
  }

  .footer-text {
    color: #858d97;
    margin-right: 8px;
    margin-bottom: 2px;
  }

</style>


// WEBPACK FOOTER //
// src/components/shared_components/part/MenuBar.vue